// extracted by mini-css-extract-plugin
export default {"iconPanelTitle":"IconPanel_iconPanelTitle__4Easy"};